import { ProcessedSearchResult } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import { IntlShape } from '@redbubble/next/intl';
import { CarouselMediaCardProps } from '../../../../components/CarouselSection/types';
import { PriceProps } from '../../../../components/Price';
import { ListsInclusions } from '../../../../types/shop-bff/types';
import { getPreviewUrl } from '../../../../utils/common';
import { PreviewStyle } from '../../../i/constants';
import { messages } from '../messages';

export const mapSearchResultPriceProps = (
  inputData: ProcessedSearchResult
): PriceProps | null => {
  if (!inputData?.inventoryItem?.price) return null;

  const { discount, currency, amount } = inputData.inventoryItem.price;

  return {
    discount,
    currency,
    amount,
  };
};

export const mapSearchResultMediaCardProps = (
  listsInclusions: ListsInclusions | null
) => {
  return (
    inputData: ProcessedSearchResult,
    intl: IntlShape
  ): CarouselMediaCardProps | null => {
    const { inventoryItem } = inputData;
    if (!inventoryItem) return null;

    const { work } = inventoryItem;
    // TODO: When IHS schema updates, remove nullish option
    const artistName = work.artistShopDisplayName ?? undefined;

    return {
      productId: inventoryItem.id,
      link: inventoryItem.productPageUrl || '',
      imageSrc: getPreviewUrl(inventoryItem, PreviewStyle.CLOSE_PREVIEW),
      title: `${work.title} ${inventoryItem.description}`,
      workTitle: work.title,
      artistName,
      matureContent: work.matureContent,
      caption: intl.formatMessage(messages.byArtist, {
        artistName,
      }),
      tags: work.tags,
      loading: false,
      testId: `suggested-product-card`,
      addToListButtonProps: {
        inventoryItem,
        workId: work.id,
        listsInclusions,
      },
      stockStatus: inventoryItem.stockStatus,
    };
  };
};
